import { Action, createReducer, on } from '@ngrx/store';

import { Auth } from './auth.models';
import { AuthorizationActions, AuthorizationApiActions, AuthorizationLocalStorageActions } from './auth.actions';

export interface AuthState {
  entity: Auth | null;
  loading: boolean;
}

export const initialState: AuthState = {
  entity: null,
  loading: false,
};

const authReducer = createReducer(
  initialState,
  on(
    AuthorizationActions.login,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationActions.register,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationActions.logout,
    (state): AuthState => ({
      ...state,
      entity: null,
      loading: false,
    })
  ),
  on(
    AuthorizationActions.resetPassword,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationActions.confirmNewPassword,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationActions.refreshAuthToken,
    (state): AuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationApiActions.loginSuccess,
    (state, { auth }): AuthState => ({
      ...state,
      entity: auth,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.loginFailure,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.registerSuccess,
    (state, { auth }): AuthState => ({
      ...state,
      entity: auth,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.registerFailure,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.resetPasswordSuccess,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.resetPasswordFailure,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.confirmNewPasswordSuccess,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.confirmNewPasswordFailure,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.refreshAuthTokenSuccess,
    (state, { auth }): AuthState => ({
      ...state,
      entity: auth,
      loading: false,
    })
  ),
  on(
    AuthorizationApiActions.refreshAuthTokenFailure,
    (state): AuthState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationLocalStorageActions.setAuthToken,
    (state, { auth }): AuthState => ({
      ...state,
      entity: auth,
      loading: false,
    })
  )
);

export function reducer(state: AuthState | undefined, action: Action) {
  return authReducer(state, action);
}
